import React from 'react';
import { motion } from 'framer-motion';
import { useSite } from '../content/SiteContext';

const gradientStyle = {
  background: 'linear-gradient(-45deg, #0f0f23, #1a1a2e, #16213e, #0f0f23)',
  backgroundSize: '400% 400%',
  animation: 'gradientBG 20s ease infinite',
  width: '100%',
  height: '100%',
  position: 'absolute',
  inset: 0,
  zIndex: 0,
};

// Agregamos la animación global al documento si no existe
if (typeof document !== 'undefined' && !document.getElementById('gradientBGKeyframes')) {
  const style = document.createElement('style');
  style.id = 'gradientBGKeyframes';
  style.innerHTML = `
    @keyframes gradientBG {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `;
  document.head.appendChild(style);
}

const QuoteSection = () => {
  const { content, t } = useSite();
  const quote = content.quote;
  return (
    <section id="quote-section" className="py-20 md:py-32 relative overflow-hidden">
      {/* Fondo animado más oscuro */}
      <div style={gradientStyle}></div>
      {/* Capa de oscurecimiento más intensa */}
      <div className="absolute inset-0 bg-black opacity-60 z-10"></div>
      
      {/* Elementos decorativos de fondo */}
      <div className="absolute inset-0 z-5">
        <div className="absolute top-20 left-20 w-96 h-96 bg-purple-500/3 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-blue-500/3 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-indigo-500/2 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl md:max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          {/* Comillas decorativas más elegantes */}
          <motion.div
            className="text-6xl md:text-9xl lg:text-[12rem] text-white/10 mb-8 md:mb-12 font-serif"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            "
          </motion.div>

          {/* Cita principal con mejor tipografía */}
          <motion.blockquote
            className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-light text-white mb-8 md:mb-12 leading-tight max-w-3xl md:max-w-4xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true, amount: 0.3 }}
              className="font-light"
            >
              "{t(quote.text)}"
            </motion.span>
          </motion.blockquote>

          {/* Autor con diseño más elegante */}
          <motion.div
            className="flex flex-col items-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.div
              className="text-center"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.8 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <h3 className="text-xl md:text-2xl font-light text-white mb-2 tracking-wide">
                {t(quote.author)}
              </h3>
              <p className="text-gray-400 text-base md:text-lg font-light">
                {t(quote.role)}
              </p>
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default QuoteSection; 